export default __webpack_public_path__ + "static/media/elipsis-icon.a1e6808d.svg";